
<div
  class="cmp-login-section fit column no-wrap justify-between ws-typography"
>
  <!--    LOGO   -->
  <div class="login-header row">
    <img alt="logo" v-bind="logo" />
  </div>
  <!--    FIRST AND ONLY SCREEN FOR CEE  -->
  <div v-if="!bankIdAllowed" class="cmp-login-section__first-step">
    <div class="section login-content row">
      <div class="col">
        <h6>{{ $t('login.existing.title') }}</h6>
        <small class="block q-mb-lg">{{ $t('login.existing.text') }}</small>
        <div>
          <ws-button
            :type="WsButtonEnum.Type.PRIMARY"
            :size="WsButtonEnum.Size.XL"
            :loading="loadingRedirect"
            :label="$t('login.existing.btn')"
            full-width
            @click="goToLogin"
          />
        </div>
        <ws-delimiter text="wsk.general.or" class="q-my-lg" />
        <h6 class="second-title">
          {{ $t('login.new.title') }}
        </h6>
        <small class="block q-mb-lg">{{ $t('login.new.text') }}</small>
        <ws-button
          :type="WsButtonEnum.Type.SECONDARY"
          :size="WsButtonEnum.Size.XL"
          :loading="loadingGoNext"
          :label="$t('login.new.btn')"
          class="cy--login-section--register"
          full-width
          @click="goNext"
        />
      </div>
    </div>
  </div>

  <!--    SECOND STEP SCREEN FOR SE   -->
  <feature-wrapper v-if="bankIdAllowed" :feature="Features.BankIdLogin">
    <slot>
      <bank-id-create-profile
        @goBack="goBack"
      />
      <ws-button
        :size="WsButtonEnum.Size.SMALL"
        :aria-label="$t('bank_id.accessibility.manual_creation')"
        :loading="loadingGoNext"
        :label="$t('login.new.manual')"
        class="cy--login-section--register"
        full-width
        @click="goNext"
      />
    </slot>
  </feature-wrapper>
  <!--    FOOTER    -->
  <div class="login-footer q-mt-lg">
    <hr class="ws-default" />

    <div class="row content items-center">
      <div v-if="footerImage && footerImage.src" class="col-auto q-pr-xl gt-sm">
        <img alt="" v-bind="footerImage" />
      </div>
      <div class="col footer-content">
        <h6 class="ws-typo-button">
          {{ $t('login.footer.title') }}
        </h6>

        <small>
          {{ $t('login.footer.text1') }}
          <a class="ws-link" :href="footerTextUrl" target="_blank">{{
            $t('login.footer.link')
          }}</a>
          {{ $t('login.footer.text2') }}
        </small>
      </div>
    </div>
  </div>
</div>
